/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {TemplateHtmlDTO} from '../model/templateHtmlDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import { Pageable } from '../model/pageable';


@Injectable()
export class ConfiguratorTemplateHtmlService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer un nouveau TemplateHtml
     * Cette requête permet de créer un nouveau TemplateHtml.&lt;br&gt;Le TemplateHtml est créé avec les données du TemplateHtmlDTO.&lt;br&gt;En cas de succès, le code 201 (Created) est renvoyé avec le lien du TemplateHtml créé.&lt;br&gt;Si non, et si le TemplateHtmlDTO a déjà un identifiant alors le code 400 (Bad Request) est renvoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#39;identifiant du datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param templateHtmlDTO templateHtmlDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTemplateHtmlUsingPOST(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe?: 'body', reportProgress?: boolean): Observable<TemplateHtmlDTO>;
    public createTemplateHtmlUsingPOST(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TemplateHtmlDTO>>;
    public createTemplateHtmlUsingPOST(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TemplateHtmlDTO>>;
    public createTemplateHtmlUsingPOST(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTemplateHtmlUsingPOST.');
        }

        if (templateHtmlDTO === null || templateHtmlDTO === undefined) {
            throw new Error('Required parameter templateHtmlDTO was null or undefined when calling createTemplateHtmlUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TemplateHtmlDTO>(`${this.basePath}/api/template-html`,
            templateHtmlDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un TemplateHtml
     * Cette requête permet de supprimer un TemplateHtml.&lt;br&gt;En cas de succès, le code 204 (NO_CONTENT) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTemplateHtmlUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTemplateHtmlUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTemplateHtmlUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTemplateHtmlUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteTemplateHtmlUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTemplateHtmlUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/template-html/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tous les TemplateHtmls
     * Cette requête permet de lister tous les TemplateHtmls.&lt;br&gt;En cas de succès, le code 200 (OK) est renvoyé avec la liste des TemplateHtmls.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#39;identifiant du datastore/tenant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; la réponse est paginée.
     * @param xDataStoreID X-DataStoreID
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTemplateHtmlsUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateHtmlDTO>>;
    public getAllTemplateHtmlsUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateHtmlDTO>>>;
    public getAllTemplateHtmlsUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateHtmlDTO>>>;
    public getAllTemplateHtmlsUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTemplateHtmlsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TemplateHtmlDTO>>(`${this.basePath}/api/template-html`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

   /**
     * Lister tous les TemplateHtmls d&#x27;un partenaire
     * Cette requête permet de lister tous les TemplateHtmls d&#x27;un partenaire.&lt;br&gt;En cas de succès, le code 200 (OK) est renvoyé avec la liste des TemplateHtmls du partenaire.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#x27;identifiant du datastore/tenant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;partner&lt;/b&gt; est le code qui correspond à l&#x27;identifiant du partenaire.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; la réponse est paginée.
    * @param xDataStoreID
    * @param partner
    * @param pageable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
   public getAllTemplateHtmlsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateHtmlDTO>>;
   public getAllTemplateHtmlsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateHtmlDTO>>>;
   public getAllTemplateHtmlsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateHtmlDTO>>>;
   public getAllTemplateHtmlsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

       if (xDataStoreID === null || xDataStoreID === undefined) {
           throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTemplateHtmlsByPartner.');
       }

       if (partner === null || partner === undefined) {
           throw new Error('Required parameter partner was null or undefined when calling getAllTemplateHtmlsByPartner.');
       }

       if (pageable === null || pageable === undefined) {
           throw new Error('Required parameter pageable was null or undefined when calling getAllTemplateHtmlsByPartner.');
       }

       let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
       if (partner !== undefined && partner !== null) {
           queryParameters = queryParameters.set('partner', <any>partner);
       }
       if (pageable !== undefined && pageable !== null) {
           // l'API attend page / size / sort, pas un objet « pageable »
           if (pageable.page !== undefined && pageable.page !== null) {
               queryParameters = queryParameters.set('page', <any>pageable.page);
           }
           if (pageable.size !== undefined && pageable.size !== null) {
               queryParameters = queryParameters.set('size', <any>pageable.size);
           }
           if (pageable.sort?.length) {
               queryParameters = queryParameters.set('sort', pageable.sort.join(','));
           }
       }

       let headers = this.defaultHeaders;
       if (xDataStoreID !== undefined && xDataStoreID !== null) {
           headers = headers.set('X-DataStoreID', String(xDataStoreID));
       }

       // to determine the Accept header
       const httpHeaderAccepts: string[] = [
           'application/json'
       ];
       const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
       if (httpHeaderAcceptSelected != undefined) {
           headers = headers.set('Accept', httpHeaderAcceptSelected);
       }

       // to determine the Content-Type header
       const consumes: string[] = [
       ];

       return this.httpClient.request<Array<TemplateHtmlDTO>>('get',`${this.basePath}/api/template-html/partner`,
           {
               params: queryParameters,
               withCredentials: this.configuration.withCredentials,
               headers: headers,
               observe: observe,
               reportProgress: reportProgress
           }
       );
   }

    /**
     * Récupérer un TemplateHtml par ses tags
     * Cette requête permet de récupérer un TemplateHtml par ses tags.&lt;br&gt;En cas de succès, le code 200 (OK) est renvoyé avec le TemplateHtml.&lt;br&gt;Si non, et si aucun TemplateHtml ne correspond aux tags, alors le code 404 (Not Found) est renvoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#39;identifiant du datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param tag tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOneTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<TemplateHtmlDTO>;
    public getOneTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TemplateHtmlDTO>>;
    public getOneTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TemplateHtmlDTO>>;
    public getOneTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getOneTemplateHtmlByTagsUsingGET.');
        }

        if (tag === null || tag === undefined) {
            throw new Error('Required parameter tag was null or undefined when calling getOneTemplateHtmlByTagsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tag) {
            tag.forEach((element) => {
                queryParameters = queryParameters.append('tag', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TemplateHtmlDTO>(`${this.basePath}/api/template-html/findone`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTemplateHtmlByCode
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplateHtmlByCodeUsingGET(xDataStoreID: string, code: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateHtmlDTO>>;
    public getTemplateHtmlByCodeUsingGET(xDataStoreID: string, code: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateHtmlDTO>>>;
    public getTemplateHtmlByCodeUsingGET(xDataStoreID: string, code: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateHtmlDTO>>>;
    public getTemplateHtmlByCodeUsingGET(xDataStoreID: string, code: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTemplateHtmlByCodeUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getTemplateHtmlByCodeUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code) {
            code.forEach((element) => {
                queryParameters = queryParameters.append('code', <any> element);
            });
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TemplateHtmlDTO>>(`${this.basePath}/api/template-html-code`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer les TemplateHtmls par leurs tags
     * Cette requête permet de récupérer les TemplateHtmls par leurs tags.&lt;br&gt;En cas de succès, le code 200 (OK) est renvoyé avec la liste des TemplateHtmls.&lt;br&gt;Si non, et si aucun TemplateHtml ne correspond aux tags, alors le code 404 (Not Found) est renvoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#39;identifiant du datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param tag tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateHtmlDTO>>;
    public getTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateHtmlDTO>>>;
    public getTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateHtmlDTO>>>;
    public getTemplateHtmlByTagsUsingGET(xDataStoreID: string, tag: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTemplateHtmlByTagsUsingGET.');
        }

        if (tag === null || tag === undefined) {
            throw new Error('Required parameter tag was null or undefined when calling getTemplateHtmlByTagsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tag) {
            tag.forEach((element) => {
                queryParameters = queryParameters.append('tag', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TemplateHtmlDTO>>(`${this.basePath}/api/template-html/find`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer un TemplateHtml par son identifiant
     * Cette requête permet de récupérer un TemplateHtml par son identifiant.&lt;br&gt;En cas de succès, le code 200 (OK) est renvoyé avec le TemplateHtml.&lt;br&gt;Si non, et si le TemplateHtml n&#39;existe pas, alors le code 404 (Not Found) est renvoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#39;identifiant du datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplateHtmlUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<TemplateHtmlDTO>;
    public getTemplateHtmlUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TemplateHtmlDTO>>;
    public getTemplateHtmlUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TemplateHtmlDTO>>;
    public getTemplateHtmlUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTemplateHtmlUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTemplateHtmlUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TemplateHtmlDTO>(`${this.basePath}/api/template-html/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour un TemplateHtml
     * Cette requête permet de mettre à jour un TemplateHtml.&lt;br&gt;Le TemplateHtml est mis à jour avec les données du TemplateHtmlDTO.&lt;br&gt;En cas de succès, le code 200 (OK) est renvoyé.&lt;br&gt;Si non, et si le TemplateHtmlDTO n&#39;est pas valide, alors le code 400 (Bad Request) est renvoyé.&lt;br&gt;Si non, et si le TemplateHtmlDTO n&#39;a pas pu être mis à jour, alors le code 500 (Internal Server Error) est renvoyé.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &lt;b&gt;X_DATASTORE_ID&lt;/b&gt; est le code qui correspond à l&#39;identifiant du datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param templateHtmlDTO templateHtmlDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTemplateHtmlUsingPUT(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe?: 'body', reportProgress?: boolean): Observable<TemplateHtmlDTO>;
    public updateTemplateHtmlUsingPUT(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TemplateHtmlDTO>>;
    public updateTemplateHtmlUsingPUT(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TemplateHtmlDTO>>;
    public updateTemplateHtmlUsingPUT(xDataStoreID: string, templateHtmlDTO: TemplateHtmlDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTemplateHtmlUsingPUT.');
        }

        if (templateHtmlDTO === null || templateHtmlDTO === undefined) {
            throw new Error('Required parameter templateHtmlDTO was null or undefined when calling updateTemplateHtmlUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<TemplateHtmlDTO>(`${this.basePath}/api/template-html`,
            templateHtmlDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    // ============ EXPORT/IMPORT METHODS ============

    /**
     * Exporter un TemplateHtml au format JSON
     * Cette requête permet d'exporter un TemplateHtml au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportTemplateHtmlJson(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportTemplateHtmlJson(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportTemplateHtmlJson(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportTemplateHtmlJson(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportTemplateHtmlJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportTemplateHtmlJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/template-html/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs TemplateHtmls au format ZIP
     * Cette requête permet d'exporter plusieurs TemplateHtmls dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportTemplateHtmlsZip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportTemplateHtmlsZip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportTemplateHtmlsZip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportTemplateHtmlsZip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportTemplateHtmlsZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportTemplateHtmlsZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/template-html/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer un TemplateHtml depuis JSON
     * Cette requête permet d'importer un TemplateHtml depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importTemplateHtmlJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<TemplateHtmlDTO>;
    public importTemplateHtmlJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TemplateHtmlDTO>>;
    public importTemplateHtmlJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TemplateHtmlDTO>>;
    public importTemplateHtmlJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importTemplateHtmlJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importTemplateHtmlJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<TemplateHtmlDTO>('post',`${this.basePath}/api/template-html/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs TemplateHtmls depuis ZIP
     * Cette requête permet d'importer plusieurs TemplateHtmls depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importTemplateHtmlsZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateHtmlDTO>>;
    public importTemplateHtmlsZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateHtmlDTO>>>;
    public importTemplateHtmlsZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateHtmlDTO>>>;
    public importTemplateHtmlsZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importTemplateHtmlsZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importTemplateHtmlsZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<TemplateHtmlDTO>>('post',`${this.basePath}/api/template-html/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
